var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/@fortawesome/pro-solid-svg-icons/faXmark.js
var require_faXmark = __commonJS({
  "../../node_modules/@fortawesome/pro-solid-svg-icons/faXmark.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "fas";
    var iconName = "xmark";
    var width = 384;
    var height = 512;
    var aliases = [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"];
    var unicode = "f00d";
    var svgPathData = "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faXmark = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/free-solid-svg-icons/faSun.js
var require_faSun = __commonJS({
  "../../node_modules/@fortawesome/free-solid-svg-icons/faSun.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "fas";
    var iconName = "sun";
    var width = 512;
    var height = 512;
    var aliases = [9728];
    var unicode = "f185";
    var svgPathData = "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faSun = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/free-solid-svg-icons/faMoon.js
var require_faMoon = __commonJS({
  "../../node_modules/@fortawesome/free-solid-svg-icons/faMoon.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "fas";
    var iconName = "moon";
    var width = 384;
    var height = 512;
    var aliases = [127769, 9214];
    var unicode = "f186";
    var svgPathData = "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faMoon = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// src/components/ThemeEditor/ThemeEditor.tsx
var import_faXmark2 = __toESM(require_faXmark());
import { useEffect as useEffect3 } from "react";
import { Modal as Modal2, Button as Button2 } from "@appcues/sonar";
import { Icon as Icon3 } from "@appcues/sonar-builder";

// src/context/Context.tsx
import { createContext, useContext } from "react";
var Context = createContext(void 0);
var useThemeEditor = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error(
      "useThemeEditor must be used within an ThemeEditorProvider"
    );
  }
  return context;
};
var Context_default = Context;

// src/components/DonateComponentModal/DonateComponentModal.tsx
var import_faXmark = __toESM(require_faXmark());
import { useEffect as useEffect2, useState as useState2 } from "react";
import styled2 from "styled-components";
import {
  Text,
  Form,
  FormField,
  InlineMessage,
  Label,
  Input,
  Modal,
  Icon as Icon2,
  Button,
  Alert,
  Stack
} from "@appcues/sonar";
import { get as get2 } from "object-path-immutable";
import camelCase from "lodash.camelcase";
import startCase from "lodash.startcase";

// src/lib/preview/style-from.ts
import { get } from "object-path-immutable";
var getTokenValueFromPath = (tokens, path) => get(tokens, path)?.$value;
var resolveTokenValue = (theme, reference, overrideId) => {
  const path = reference.replace(/[{}]/g, "");
  if (overrideId) {
    const overrideTokens = theme.content.overrides?.find(
      ({ id }) => id === overrideId
    )?.tokens;
    if (overrideTokens) {
      const value2 = getTokenValueFromPath(overrideTokens, path);
      if (value2) {
        if (value2.startsWith("{")) {
          return resolveTokenValue(theme, value2);
        }
        return value2;
      }
    }
  }
  const value = getTokenValueFromPath(theme.content.tokens, path);
  if (value) {
    if (value.startsWith("{")) {
      return resolveTokenValue(theme, value);
    }
    return value;
  }
  return reference;
};
var transformValue = (value) => {
  if (typeof value === "string" && value.endsWith("px")) {
    return Number.parseFloat(value);
  }
  if (value === "100%") {
    return -1;
  }
  return value;
};
var handleFontFamily = (theme, styleObject, overrideId) => {
  const path = styleObject.fontFamily.replace(/[{}]/g, "");
  const tokenObj = get(theme.content.tokens, path);
  const fontExtensions = tokenObj?.$extensions?.["com.appcues.theme.font"];
  const fontWeight = resolveTokenValue(theme, styleObject.fontWeight, overrideId) || "regular";
  const mobileFontName = fontExtensions?.mobile?.[fontWeight];
  return mobileFontName;
};
var styleFrom = (theme, path, overrideId) => {
  const componentStyle = get(theme.content.components, `${path}.$style`);
  const override = theme.content.overrides?.find(({ id }) => id === overrideId);
  const overrideStyle = override ? get(override.components, `${path}.$style`) : void 0;
  if (!componentStyle && !overrideStyle) return {};
  const mergedStyle = {
    ...componentStyle,
    ...overrideStyle
  };
  const resolveStyleTokens = (styleObject) => {
    if (typeof styleObject !== "object" || styleObject === null) {
      return styleObject;
    }
    return Object.entries(styleObject).reduce(
      (acc, [key, value]) => {
        if (key === "fontFamily") {
          const val = handleFontFamily(theme, styleObject, overrideId);
          acc.fontName = val;
          return acc;
        }
        if (typeof value === "string" && value.startsWith("{")) {
          acc[key] = transformValue(
            resolveTokenValue(theme, value, overrideId)
          );
        } else if (typeof value === "object") {
          acc[key] = resolveStyleTokens(value);
        } else {
          acc[key] = transformValue(value);
        }
        return acc;
      },
      {}
    );
  };
  return resolveStyleTokens(mergedStyle);
};

// src/lib/preview/make-mobile-experience.ts
var stackBlockWrapper = (content) => ({
  type: "stack",
  id: `${content.id}-stack`,
  orientation: "horizontal",
  distribution: "equal",
  items: [
    {
      type: "block",
      blockType: "image",
      id: `${content.id}-block`,
      content
    }
  ]
});
var makeImageRows = (theme) => Object.keys(theme.content.components?.image || {}).map(
  (imageKey) => stackBlockWrapper({
    type: "image",
    id: `image.${imageKey}-image`,
    imageUrl: "https://images.appcues.com/v1658371422/mobile-builder/default-image.jpg",
    style: styleFrom(theme, `image.${imageKey}`)
  })
);
var makeTextRows = (theme) => Object.keys(theme.content.components?.text || {}).map(
  (textKey) => stackBlockWrapper({
    type: "text",
    id: `text.${textKey}-text`,
    text: `${textKey.charAt(0).toUpperCase() + textKey.slice(1)} text`,
    style: styleFrom(theme, `text.${textKey}`)
  })
);
var makeButtonRows = (theme) => Object.keys(theme.content.components?.button || {}).map(
  (buttonKey) => stackBlockWrapper({
    type: "button",
    id: `${buttonKey}-button`,
    content: {
      type: "text",
      id: `${buttonKey}-text`,
      text: `${buttonKey.charAt(0).toUpperCase() + buttonKey.slice(1)} Button`,
      style: styleFrom(theme, `button.${buttonKey}.text`)
    },
    style: styleFrom(theme, `button.${buttonKey}`)
  })
);
var makeMobileExperience = (theme) => ({
  id: "exp-0",
  name: "POC Modal One",
  type: "mobile",
  tags: [],
  theme: "",
  actions: {},
  traits: [],
  steps: [
    {
      id: "step-group-0",
      type: "group",
      actions: {},
      traits: [
        {
          type: "@appcues/modal",
          config: {
            presentationStyle: "dialog",
            style: styleFrom(theme, "container.modal.default")
          }
        },
        {
          type: "@appcues/backdrop",
          config: styleFrom(theme, "container.modal.default.backdrop")
        }
      ],
      children: [
        {
          id: "step-child-0",
          type: "modal",
          contentType: "application/json",
          content: {
            type: "stack",
            orientation: "vertical",
            id: "main-stack",
            style: {},
            items: [
              ...makeImageRows(theme),
              ...makeTextRows(theme),
              ...makeButtonRows(theme)
            ]
          },
          traits: [],
          actions: {}
        }
      ]
    }
  ]
});
var wrapMobileComponentPreview = ({
  traits,
  block
}) => ({
  id: "exp-0",
  name: "Component",
  type: "mobile_embed",
  tags: [],
  theme: "",
  actions: {},
  traits: [],
  steps: [
    {
      id: "step-group-0",
      type: "group",
      actions: {},
      traits: traits ?? [
        {
          type: "@appcues/embedded",
          config: {
            presentationStyle: "embed"
          }
        }
      ],
      children: [
        {
          id: "step-child-0",
          type: "modal",
          contentType: "application/json",
          content: {
            type: "stack",
            orientation: "vertical",
            id: "main-stack",
            style: {},
            items: [
              block ?? stackBlockWrapper({
                type: "text",
                id: "text-0",
                text: "",
                style: {
                  fontSize: 16,
                  marginTop: 48,
                  marginBottom: 48
                }
              })
            ]
          },
          traits: [],
          actions: {}
        }
      ]
    }
  ]
});

// src/components/PreviewPane/PreviewPane.tsx
var import_faSun = __toESM(require_faSun());
var import_faMoon = __toESM(require_faMoon());
import { useState } from "react";
import { SegmentedControl } from "@appcues/sonar";
import { Icon } from "@appcues/sonar-builder";

// src/components/PreviewPane/MobilePreviewFrame.tsx
import { useEffect, useRef } from "react";

// src/components/PreviewPane/PreviewPane.styled.ts
import styled from "styled-components";
var Panel = styled.div`
  background-color: ${({ colorMode }) => colorMode === "dark" ? "#000" : "#fff"};
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
var ControlBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0 var(--spacing-regular);
  padding: var(--spacing-regular) 0;
  border-bottom: 1px solid var(--border-default);
`;
var PreviewWrapper = styled.div`
  position: relative;
  flex: 1;
`;
var PreviewTitle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: var(--spacing-regular);
  font-weight: var(--bold);
  line-height: normal;
`;
var PreviewFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  pointer-events: none;
`;
var Preview = {
  Wrapper: PreviewWrapper,
  Title: PreviewTitle,
  Frame: PreviewFrame
};

// src/components/PreviewPane/MobilePreviewFrame.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var MobilePreviewFrame = ({
  title,
  mobileExperience,
  colorMode = "light"
}) => {
  const iframeRef = useRef(null);
  const srcUrl = `${window.location.origin}/image-service`;
  useEffect(() => {
    const iframe = iframeRef.current?.contentWindow;
    if (iframe) {
      iframe.addEventListener("load", () => {
        iframe.apc_set_mobile_experience?.(mobileExperience, "step-child-0", {
          colorMode
        });
      });
    }
  });
  useEffect(() => {
    const iframe = iframeRef.current?.contentWindow;
    if (iframe) {
      iframe.apc_set_mobile_experience?.(mobileExperience, "step-child-0", {
        colorMode
      });
    }
  }, [mobileExperience, colorMode]);
  return /* @__PURE__ */ jsxs(Preview.Wrapper, { children: [
    /* @__PURE__ */ jsx(
      Preview.Frame,
      {
        ref: iframeRef,
        title,
        scrolling: "no",
        src: srcUrl
      }
    ),
    title && /* @__PURE__ */ jsx(Preview.Title, { children: title })
  ] });
};

// src/components/PreviewPane/PreviewPane.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var PreviewPane = ({ theme }) => {
  const [colorMode, setColorMode] = useState("light");
  return /* @__PURE__ */ jsxs2(Panel, { colorMode, "data-theme": colorMode, children: [
    /* @__PURE__ */ jsx2(ControlBar, { children: /* @__PURE__ */ jsxs2(
      SegmentedControl.Root,
      {
        iconOnly: true,
        type: "single",
        value: colorMode,
        "aria-label": "Preview mode",
        onValueChange: (value) => setColorMode(value),
        children: [
          /* @__PURE__ */ jsx2(SegmentedControl.Item, { value: "light", children: /* @__PURE__ */ jsx2(Icon, { icon: import_faSun.faSun }) }),
          /* @__PURE__ */ jsx2(SegmentedControl.Item, { value: "dark", children: /* @__PURE__ */ jsx2(Icon, { icon: import_faMoon.faMoon }) })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx2(
      MobilePreviewFrame,
      {
        mobileExperience: makeMobileExperience(theme),
        colorMode
      }
    )
  ] });
};

// src/components/DonateComponentModal/DonateComponentModal.tsx
import { Fragment, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var Preview2 = styled2.div`
  display: flex;
  border: 1px solid var(--border-default);
  border-radius: var(--border-radius-x-small);

  > div:nth-child(n + 2)::before {
    content: '';
    position: absolute;
    top: var(--spacing-regular);
    bottom: var(--spacing-regular);
    left: 0;
    width: 1px;
    background-color: var(--border-default);
  }
`;
var makeUpdatedComponentDefinition = (base, delta) => {
  const result = { ...base };
  Object.entries(delta).forEach(([key, value]) => {
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      result[key] = makeUpdatedComponentDefinition(result[key] || {}, value);
    } else if (value === void 0) {
      delete result[key];
    } else {
      result[key] = delta[key];
    }
  });
  return result;
};
var DonateComponentModal = ({
  onSave
}) => {
  const { theme, updateTheme, donatedComponent, setDonatedComponent } = useThemeEditor();
  const [componentName, setComponentName] = useState2("");
  const [saveState, setSaveState] = useState2(
    "idle"
  );
  const { isCreate, type, existingPath } = donatedComponent ?? {};
  const existingName = existingPath?.split(".").pop();
  const path = isCreate ? `${type}.${camelCase(componentName)}` : existingPath;
  useEffect2(() => {
    const initialName = existingName ? `${existingName.split(".").pop()} 2` : void 0;
    setComponentName(initialName ?? "");
    setSaveState("idle");
  }, [existingName]);
  useEffect2(() => {
    if (saveState === "pending") {
      onSave({ updateFromDonation: path });
      setSaveState("saving");
    }
  }, [saveState, onSave, path]);
  if (!donatedComponent || !theme) return null;
  const unavailableNames = Object.keys(
    theme.content.components[donatedComponent.type] ?? {}
  );
  const showErrors = saveState === "idle";
  const nameIsError = showErrors && unavailableNames.includes(camelCase(componentName));
  const handleSave = () => {
    const existingComponent = get2(theme.content.components, existingPath) ?? {};
    const updatedComponent = makeUpdatedComponentDefinition(
      existingComponent,
      donatedComponent.componentDefinition
    );
    updateTheme(`content.components.${path}`, updatedComponent);
    setSaveState("pending");
  };
  return /* @__PURE__ */ jsxs3(
    Modal.Root,
    {
      open: donatedComponent !== null,
      onOpenChange: () => setDonatedComponent(null),
      children: [
        /* @__PURE__ */ jsx3(Modal.Title, { children: isCreate ? "Add new variant" : `Update \u201C${startCase(existingName)}\u201D` }),
        /* @__PURE__ */ jsx3(Modal.Close, { "aria-label": "Close", children: /* @__PURE__ */ jsx3(Icon2, { size: "large", icon: import_faXmark.faXmark }) }),
        /* @__PURE__ */ jsxs3(Form, { "aria-label": "save component form", role: "form", children: [
          /* @__PURE__ */ jsxs3(Stack, { children: [
            isCreate && /* @__PURE__ */ jsxs3(Fragment, { children: [
              /* @__PURE__ */ jsxs3(Text, { children: [
                "Save your changes as a new variant so it can be reused in flows that use the theme \u201C",
                theme.name,
                "\u201D."
              ] }),
              /* @__PURE__ */ jsxs3(FormField, { children: [
                /* @__PURE__ */ jsx3(Label, { htmlFor: "name", children: "Variant name" }),
                /* @__PURE__ */ jsx3(
                  Input,
                  {
                    id: "name",
                    defaultValue: componentName,
                    onChange: (event) => setComponentName(event.target.value),
                    placeholder: "Component name"
                  }
                ),
                nameIsError && /* @__PURE__ */ jsxs3(InlineMessage, { variant: "error", children: [
                  "\u201C",
                  componentName,
                  "\u201D already exists."
                ] })
              ] })
            ] }),
            !isCreate && /* @__PURE__ */ jsx3(Alert.Root, { variant: "warning", children: /* @__PURE__ */ jsx3(Alert.Title, { children: "This updated style will immediately be applied to all flows that use this variant." }) }),
            /* @__PURE__ */ jsxs3(Preview2, { children: [
              donatedComponent.originalReferenceModel && /* @__PURE__ */ jsx3(
                MobilePreviewFrame,
                {
                  title: "Original",
                  mobileExperience: wrapMobileComponentPreview(
                    donatedComponent.originalReferenceModel
                  )
                }
              ),
              /* @__PURE__ */ jsx3(
                MobilePreviewFrame,
                {
                  title: isCreate ? "Preview" : "Updated",
                  mobileExperience: wrapMobileComponentPreview(
                    donatedComponent.referenceModel
                  )
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsxs3(Modal.Actions, { children: [
            /* @__PURE__ */ jsx3(
              Button,
              {
                type: "button",
                variant: "tertiary",
                onClick: () => setDonatedComponent(null),
                children: "Cancel"
              }
            ),
            /* @__PURE__ */ jsx3(
              Button,
              {
                type: "button",
                variant: "primary",
                disabled: isCreate && !(componentName && !nameIsError),
                onClick: handleSave,
                children: isCreate ? "Save" : "Update variant"
              }
            )
          ] })
        ] })
      ]
    }
  );
};

// src/components/StyleSettings/StyleSettings.tsx
import { Accordion as Accordion4 } from "@appcues/sonar";

// src/components/StyleSettings/OverviewSection.tsx
import { useState as useState3 } from "react";
import { Accordion, Input as Input2, Label as Label2, Switch } from "@appcues/sonar";

// src/lib/color-handler.ts
var updateToDarkMode = (enabled, components) => {
  const processValue = (value) => {
    if (!value || typeof value !== "object") {
      return value;
    }
    if ("light" in value && typeof value.light === "string") {
      if (!enabled) {
        const { dark, ...rest } = value;
        return rest;
      }
      return {
        ...value,
        dark: value.light.startsWith("{colors.") ? value.light.replace("{colors.", "{colors.dark.") : value.light
      };
    }
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [key, processValue(val)])
    );
  };
  return processValue(components);
};

// src/components/StyleSettings/StyleSettings.styled.ts
import styled3 from "styled-components";
var Controls = styled3.div`
  padding: var(--spacing-large);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
`;
var FieldSet = styled3.fieldset`
  display: flex;
  flex-direction: ${({ grouped }) => grouped ? "row" : "column"};
  gap: var(--spacing-small);
  margin: 0;
  padding: 0;
  border: none;
`;
var Legend = styled3.legend`
  padding: 0;
  margin-bottom: var(--spacing-x-small);
  font-size: var(--font-size-regular);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-regular);
  color: var(--foreground-primary);
`;

// src/components/StyleSettings/OverviewSection.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var OverviewSection = ({ theme }) => {
  const { updateTheme } = useThemeEditor();
  const { name: themeName, content } = theme;
  const { meta, components } = content;
  const [name, setName] = useState3(themeName);
  const [darkMode, setDarkMode] = useState3(meta?.darkMode ?? false);
  const handleNameChange = (event) => {
    const { value } = event.target;
    setName(value);
    updateTheme("", { name: value });
  };
  const handleDarkModeChange = (checked) => {
    setDarkMode(checked);
    updateTheme("content", {
      meta: {
        ...meta,
        darkMode: checked
      },
      components: updateToDarkMode(checked, components)
    });
  };
  return /* @__PURE__ */ jsxs4(Accordion.Item, { value: "overview", children: [
    /* @__PURE__ */ jsx4(Accordion.Header, { children: /* @__PURE__ */ jsx4(Accordion.Trigger, { children: "Theme settings" }) }),
    /* @__PURE__ */ jsx4(Accordion.Content, { children: /* @__PURE__ */ jsxs4(Controls, { children: [
      /* @__PURE__ */ jsxs4(FieldSet, { children: [
        /* @__PURE__ */ jsx4(Label2, { htmlFor: "name", children: "Name" }),
        /* @__PURE__ */ jsx4(
          Input2,
          {
            id: "name",
            defaultValue: name,
            onChange: handleNameChange,
            placeholder: "Theme name"
          }
        )
      ] }),
      /* @__PURE__ */ jsx4(FieldSet, { children: /* @__PURE__ */ jsx4(
        Switch,
        {
          id: "dark-mode",
          checked: darkMode,
          onCheckedChange: handleDarkModeChange,
          fullWidth: true,
          children: /* @__PURE__ */ jsx4(Switch.Label, { htmlFor: "dark-mode", children: "Enable dark mode" })
        }
      ) })
    ] }) })
  ] });
};

// src/components/StyleSettings/ColorSection.tsx
import startCase3 from "lodash.startcase";
import { get as get3 } from "object-path-immutable";
import { Accordion as Accordion2 } from "@appcues/sonar";

// src/components/StyleSettings/ColorTokenInput.tsx
import { useState as useState4 } from "react";
import startCase2 from "lodash.startcase";
import { Input as Input3, Label as Label3 } from "@appcues/sonar";
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var ColorTokenInput = ({
  path,
  label = startCase2(path.split(".").pop()),
  token
}) => {
  const { updateTheme } = useThemeEditor();
  const [color, setColor] = useState4(token?.$value ?? "");
  const handleChange = (event) => {
    const { value } = event.target;
    setColor(value);
    updateTheme(path, {
      ...token,
      $value: value
    });
  };
  return /* @__PURE__ */ jsxs5(FieldSet, { children: [
    /* @__PURE__ */ jsx5(Label3, { htmlFor: path, children: label }),
    /* @__PURE__ */ jsx5(
      Input3,
      {
        id: path,
        value: color,
        onChange: handleChange,
        placeholder: label
      }
    )
  ] });
};

// src/components/StyleSettings/ColorSection.tsx
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var ColorSection = ({ tokens, showDarkMode }) => {
  const controls = ["foreground", "background", "primary"].map((field) => ({
    light: {
      path: `content.tokens.colors.${field}`,
      label: startCase3(field),
      token: get3(tokens, `colors.${field}`)
    },
    ...showDarkMode && {
      dark: {
        path: `content.tokens.colors.dark.${field}`,
        token: get3(tokens, `colors.dark.${field}`)
      }
    }
  }));
  return /* @__PURE__ */ jsxs6(Accordion2.Item, { value: "color", children: [
    /* @__PURE__ */ jsx6(Accordion2.Header, { children: /* @__PURE__ */ jsx6(Accordion2.Trigger, { children: "Colors" }) }),
    /* @__PURE__ */ jsx6(Accordion2.Content, { children: /* @__PURE__ */ jsx6(Controls, { children: controls.map(({ light, dark }) => /* @__PURE__ */ jsxs6(FieldSet, { grouped: !!dark, children: [
      !!dark && /* @__PURE__ */ jsx6(Legend, { children: light.label }),
      /* @__PURE__ */ jsx6(
        ColorTokenInput,
        {
          label: dark ? "Light" : light.label,
          path: light.path,
          token: light.token
        }
      ),
      dark && /* @__PURE__ */ jsx6(
        ColorTokenInput,
        {
          label: "Dark",
          path: dark.path,
          token: dark.token
        }
      )
    ] }, light.path)) }) })
  ] });
};

// src/components/StyleSettings/InterfaceSection.tsx
import { useState as useState6 } from "react";
import { get as get5 } from "object-path-immutable";
import { Accordion as Accordion3 } from "@appcues/sonar";

// src/components/RangeInput.tsx
import styled4 from "styled-components";
import { Stack as Stack2, Slider, Label as Label4, Input as Input4 } from "@appcues/sonar";
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var Container = styled4.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: var(--spacing-small);
`;
var RangeInput = ({
  label,
  value,
  min,
  max,
  step,
  onValueChange
}) => {
  return /* @__PURE__ */ jsxs7(Container, { children: [
    /* @__PURE__ */ jsxs7(Stack2, { spacing: "small", children: [
      /* @__PURE__ */ jsx7(Label4, { children: label }),
      /* @__PURE__ */ jsx7(
        Slider,
        {
          value: [value],
          min,
          max,
          step,
          onValueChange: (v) => onValueChange(v[0])
        }
      )
    ] }),
    /* @__PURE__ */ jsx7(
      Input4,
      {
        type: "number",
        min,
        max,
        value,
        onChange: (e) => onValueChange(Number(e.target.value))
      }
    )
  ] });
};

// src/lib/basic-theme-tokens.ts
import { get as get4 } from "object-path-immutable";

// src/types.ts
var TOKEN_EXTENSIONS = {
  FONT: "com.appcues.theme.font",
  PRESET: "com.appcues.theme.preset"
};
var PRESET_SIZES = ["S", "M", "L"];

// src/lib/basic-theme-tokens.ts
var PRESET_FONT_SIZES = {
  S: [12, 14, 18],
  M: [14, 16, 22],
  L: [16, 18, 24]
};
var PRESET_SPACING = {
  S: [0, 4, 6, 8, 10, 12],
  M: [0, 8, 12, 16, 20, 24],
  L: [0, 12, 18, 24, 30, 36]
};
var currentFontSize = (tokens) => {
  return get4(tokens, ["font", "size", "$extensions", TOKEN_EXTENSIONS.PRESET]);
};
var currentCornerRadius = (tokens) => Number.parseFloat(get4(tokens, "parts.container.corner-radius.$value"));
var currentSpacing = (tokens) => {
  return get4(tokens, [
    "dimensions",
    "unit",
    "$extensions",
    TOKEN_EXTENSIONS.PRESET
  ]);
};
var presetFontSizes = (size) => {
  const [small, regular, large] = PRESET_FONT_SIZES[size];
  return {
    $type: "dimension",
    $extensions: {
      [TOKEN_EXTENSIONS.PRESET]: size
    },
    small: { $value: `${small}px` },
    regular: { $value: `${regular}px` },
    large: { $value: `${large}px` }
  };
};
var presetSpacing = (size) => ({
  $type: "dimension",
  unit: {
    $extensions: {
      [TOKEN_EXTENSIONS.PRESET]: size
    },
    ...Object.fromEntries(
      PRESET_SPACING[size].map((value, i) => [
        i.toString(),
        { $value: `${value}px` }
      ])
    )
  }
});

// src/components/FontFamilySelect.tsx
import { useState as useState5 } from "react";
import startCase4 from "lodash.startcase";
import { Label as Label5, Select, SelectOption } from "@appcues/sonar";
import { Fragment as Fragment2, jsx as jsx8, jsxs as jsxs8 } from "react/jsx-runtime";
var SYSTEM_FONT_MAPPING = {
  "System Sans-serif": "System Default",
  "System Serif": "System Serif",
  "System Monospaced": "System Monospaced",
  "System Rounded": "System Rounded"
};
var systemFontMapping = (fontName) => ({
  ultralight: `${fontName} Ultralight`,
  thin: `${fontName} Thin`,
  light: `${fontName} Light`,
  regular: `${fontName} Regular`,
  medium: `${fontName} Medium`,
  semibold: `${fontName} Semibold`,
  bold: `${fontName} Bold`,
  heavy: `${fontName} Heavy`,
  black: `${fontName} Black`
});
var FontFamilySelect = ({
  path,
  label = startCase4(path.split(".").pop()),
  token
}) => {
  const { updateTheme } = useThemeEditor();
  const [fontFamily, setFontFamily] = useState5(token?.$value ?? "");
  const handleFontFamilyChange = (value) => {
    setFontFamily(value);
    const systemFontName = SYSTEM_FONT_MAPPING[value];
    updateTheme(path, {
      $value: value,
      $extensions: {
        [TOKEN_EXTENSIONS.FONT]: {
          mobile: systemFontMapping(systemFontName)
        }
      }
    });
  };
  return /* @__PURE__ */ jsxs8(Fragment2, { children: [
    /* @__PURE__ */ jsx8(Label5, { htmlFor: "font-family", children: label }),
    /* @__PURE__ */ jsxs8(
      Select,
      {
        placeholder: "Select one",
        width: "full-width",
        id: "font-family",
        name: "font-family",
        defaultValue: fontFamily,
        onValueChange: handleFontFamilyChange,
        children: [
          /* @__PURE__ */ jsx8(SelectOption, { label: "System Sans-serif", value: "System Sans-serif" }),
          /* @__PURE__ */ jsx8(SelectOption, { label: "System Serif", value: "System Serif" }),
          /* @__PURE__ */ jsx8(SelectOption, { label: "System Monospaced", value: "System Monospaced" }),
          /* @__PURE__ */ jsx8(SelectOption, { label: "System Rounded", value: "System Rounded" })
        ]
      }
    )
  ] });
};

// src/components/PresetSizeControl.tsx
import { Label as Label6, SegmentedControl as SegmentedControl2 } from "@appcues/sonar";
import { Fragment as Fragment3, jsx as jsx9, jsxs as jsxs9 } from "react/jsx-runtime";
var PresetSizeControl = ({
  label,
  value,
  onChange
}) => {
  return /* @__PURE__ */ jsxs9(Fragment3, { children: [
    /* @__PURE__ */ jsx9(Label6, { children: label }),
    /* @__PURE__ */ jsx9(
      SegmentedControl2.Root,
      {
        type: "single",
        value,
        "aria-label": label,
        onValueChange: onChange,
        children: PRESET_SIZES.map((size) => /* @__PURE__ */ jsx9(SegmentedControl2.Item, { value: size, children: size }, size))
      }
    )
  ] });
};

// src/components/StyleSettings/InterfaceSection.tsx
import { jsx as jsx10, jsxs as jsxs10 } from "react/jsx-runtime";
var InterfaceSection = ({ tokens }) => {
  const { updateTheme } = useThemeEditor();
  const [fontSize, setFontSize] = useState6(currentFontSize(tokens));
  const [cornerRadius, setCornerRadius] = useState6(currentCornerRadius(tokens));
  const [spacing, setSpacing] = useState6(currentSpacing(tokens));
  const handleFontSizeChange = (value) => {
    setFontSize(value);
    updateTheme("content.tokens.font.size", presetFontSizes(value));
  };
  const handleCornerRadiusChange = (value) => {
    setCornerRadius(value);
    updateTheme("content.tokens.parts.container.corner-radius", {
      $value: `${value}px`
    });
  };
  const handleSpacingChange = (value) => {
    setSpacing(value);
    updateTheme("content.tokens.dimensions", presetSpacing(value));
  };
  return /* @__PURE__ */ jsxs10(Accordion3.Item, { value: "interface", children: [
    /* @__PURE__ */ jsx10(Accordion3.Header, { children: /* @__PURE__ */ jsx10(Accordion3.Trigger, { children: "Interface" }) }),
    /* @__PURE__ */ jsx10(Accordion3.Content, { children: /* @__PURE__ */ jsxs10(Controls, { children: [
      /* @__PURE__ */ jsx10(FieldSet, { children: /* @__PURE__ */ jsx10(
        FontFamilySelect,
        {
          path: "content.tokens.font.family.base",
          label: "Font family",
          token: get5(tokens, "font.family.base")
        }
      ) }),
      /* @__PURE__ */ jsx10(FieldSet, { children: /* @__PURE__ */ jsx10(
        PresetSizeControl,
        {
          label: "Font size",
          value: fontSize,
          onChange: handleFontSizeChange
        }
      ) }),
      /* @__PURE__ */ jsx10(FieldSet, { children: /* @__PURE__ */ jsx10(
        RangeInput,
        {
          label: "Corner radius",
          value: cornerRadius,
          min: 0,
          max: 100,
          step: 1,
          onValueChange: handleCornerRadiusChange
        }
      ) }),
      /* @__PURE__ */ jsx10(FieldSet, { children: /* @__PURE__ */ jsx10(
        PresetSizeControl,
        {
          label: "Spacing",
          value: spacing,
          onChange: handleSpacingChange
        }
      ) })
    ] }) })
  ] });
};

// src/components/StyleSettings/StyleSettings.tsx
import { jsx as jsx11, jsxs as jsxs11 } from "react/jsx-runtime";
var StyleSettings = ({ theme }) => {
  return /* @__PURE__ */ jsxs11(
    Accordion4.Root,
    {
      defaultValue: ["overview", "color", "interface"],
      type: "multiple",
      children: [
        /* @__PURE__ */ jsx11(OverviewSection, { theme }),
        /* @__PURE__ */ jsx11(
          ColorSection,
          {
            tokens: theme.content.tokens,
            showDarkMode: theme.content.meta?.darkMode ?? false
          }
        ),
        /* @__PURE__ */ jsx11(InterfaceSection, { tokens: theme.content.tokens })
      ]
    }
  );
};

// src/components/ThemeEditor/ThemeEditor.styled.ts
import styled5 from "styled-components";
var Wrapper = styled5.div`
  display: flex;
  gap: var(--spacing-small);
  min-height: 500px;
`;
var Settings = styled5.div`
  width: 384px;
  overflow-y: auto;
  border: 1px solid var(--border-default);
  border-radius: var(--border-radius-x-small);
`;
var Preview3 = styled5.div`
  flex: 1;
  border: 1px solid var(--border-default);
  border-radius: var(--border-radius-x-small);
`;

// src/components/ThemeEditor/ThemeEditor.tsx
import { Fragment as Fragment4, jsx as jsx12, jsxs as jsxs12 } from "react/jsx-runtime";
var ThemeEditor = ({
  id,
  platform: targetPlatform,
  onPublish
}) => {
  const {
    theme,
    isEditorOpen,
    setIsEditorOpen,
    donatedComponent,
    setDonatedComponent,
    fetchTheme,
    saveTheme,
    publishTheme
  } = useThemeEditor();
  useEffect3(() => {
    if (isEditorOpen || donatedComponent !== null) {
      fetchTheme(id);
    }
  }, [isEditorOpen, donatedComponent, fetchTheme, id]);
  if (!theme) return null;
  const handleSave = async (metadata = {}) => {
    const delta = {
      id: theme.id,
      name: theme.name,
      content: theme.content
    };
    await saveTheme(delta);
    const updatedCompiledThemes = await publishTheme(theme.id);
    onPublish?.(
      updatedCompiledThemes.find(({ platform }) => platform === targetPlatform),
      metadata
    );
    setIsEditorOpen(false);
    setDonatedComponent(null);
  };
  return /* @__PURE__ */ jsxs12(Fragment4, { children: [
    /* @__PURE__ */ jsx12(DonateComponentModal, { onSave: handleSave }),
    isEditorOpen && /* @__PURE__ */ jsxs12(
      Modal2.Root,
      {
        open: isEditorOpen,
        onOpenChange: () => setIsEditorOpen(false),
        size: "large",
        children: [
          /* @__PURE__ */ jsxs12(Modal2.Title, { children: [
            "Edit Theme \u201C",
            theme.name,
            "\u201D"
          ] }),
          /* @__PURE__ */ jsx12(Modal2.Close, { "aria-label": "Close", children: /* @__PURE__ */ jsx12(Icon3, { size: "large", icon: import_faXmark2.faXmark }) }),
          /* @__PURE__ */ jsxs12(Wrapper, { children: [
            /* @__PURE__ */ jsx12(Settings, { children: /* @__PURE__ */ jsx12(StyleSettings, { theme }) }),
            /* @__PURE__ */ jsx12(Preview3, { children: /* @__PURE__ */ jsx12(PreviewPane, { theme }) })
          ] }),
          /* @__PURE__ */ jsxs12(Modal2.Actions, { children: [
            /* @__PURE__ */ jsx12(
              Button2,
              {
                type: "button",
                variant: "tertiary",
                onClick: () => setIsEditorOpen(false),
                children: "Cancel"
              }
            ),
            /* @__PURE__ */ jsx12(
              Button2,
              {
                type: "button",
                variant: "primary",
                onClick: () => handleSave(),
                children: "Save"
              }
            )
          ] })
        ]
      }
    )
  ] });
};

// src/components/Provider.tsx
import { useState as useState7, useMemo, useCallback } from "react";
import { assign } from "object-path-immutable";
import { jsx as jsx13 } from "react/jsx-runtime";
var Provider = ({
  children,
  fetchTheme: fetchThemeApi,
  saveTheme: saveThemeApi,
  publishTheme: publishThemeApi
}) => {
  const [theme, setTheme] = useState7(null);
  const [isLoading, setIsLoading] = useState7(false);
  const [isEditorOpen, setIsEditorOpen] = useState7(false);
  const [donatedComponent, setDonatedComponent] = useState7(null);
  const updateTheme = useCallback(
    (path, chunk) => {
      setTheme(assign(theme, path, chunk));
    },
    [theme]
  );
  const fetchTheme = useCallback(
    async (id) => {
      try {
        setIsLoading(true);
        const loadedTheme = await fetchThemeApi(id);
        setTheme(loadedTheme);
      } catch (error) {
        console.error("Error fetching theme:", error);
      } finally {
        setIsLoading(false);
      }
    },
    [fetchThemeApi]
  );
  const saveTheme = useCallback(
    async (model) => {
      try {
        const result = await saveThemeApi(model.id, model);
        return result;
      } catch (error) {
        console.error("Theme save failed:", error);
        throw error;
      }
    },
    [saveThemeApi]
  );
  const publishTheme = useCallback(
    async (id) => {
      try {
        const publishedThemes = await publishThemeApi(id);
        return publishedThemes;
      } catch (error) {
        console.error("Theme publish failed:", error);
        throw error;
      }
    },
    [publishThemeApi]
  );
  const value = useMemo(
    () => ({
      theme,
      setTheme,
      updateTheme,
      isLoading,
      setIsLoading,
      isEditorOpen,
      setIsEditorOpen,
      donatedComponent,
      setDonatedComponent,
      fetchTheme,
      saveTheme,
      publishTheme
    }),
    [
      theme,
      updateTheme,
      isLoading,
      isEditorOpen,
      donatedComponent,
      fetchTheme,
      saveTheme,
      publishTheme
    ]
  );
  return /* @__PURE__ */ jsx13(Context_default.Provider, { value, children });
};
export {
  Context_default as Context,
  ThemeEditor,
  Provider as ThemeEditorProvider,
  useThemeEditor
};
//# sourceMappingURL=index.mjs.map